import { debounceCallback } from "@caprikorn/dynamo-utils";
import { useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  GetChildEntityBillingAccountBills,
  GetChildEntityBillingAccountBillsParams,
} from "./apiEcms.types";

const getChildEntityBillingAccountBills = async (
  {
    customerId,
    contractId,
    ...params
  }: GetChildEntityBillingAccountBillsParams,
  signal: AbortSignal,
) => {
  const { data } = await apiEcmsHttp.get<GetChildEntityBillingAccountBills>(
    `/child-entities/${customerId}/billing-accounts/${contractId}/bills`,
    { params, signal },
  );

  return data;
};

const debouncedGetChildEntityBillingAccountBills = debounceCallback(
  getChildEntityBillingAccountBills,
);

export const useGetChildEntityBillingAccountBills = (
  params: GetChildEntityBillingAccountBillsParams,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.BILLS, params],
    queryFn: ({ signal }) =>
      debouncedGetChildEntityBillingAccountBills(params, signal),
  });
